module.exports = __webpack_public_path__ + "static/media/YM07_3.37d11a78.jpg";